export interface ICancelSubscriptionVO {
    feedbacks: CancellationDetailsFeedbackEnum;
    comments: string;
    contractId: string;
    userEmail: string;
    organizationInternalName: string;
}

export enum CancellationDetailsFeedbackEnum {
    CustumerService = "customer_service",
    Other = "other",
    MissingFeatures = "missing_features",
    SwitchedService = "switched_service",
}

export interface CreateSubscriptionDTO {
    paymentMethodId: string;
    clientName: string;
    email: string;
    priceId: string;
    Address: AddressClient;
    createdByOnboard: boolean;
    internalName: string;
}

export interface UpdatePaymentMethodVO {
    paymentMethodId: string;
    Address: AddressClient;
    needPayInvoices: boolean;
}

export interface AddressClient {
    city: string;
    line1: string;
    line2: string;
    postalCode: string;
    country: string;
    phone: string;
    state: string;
}